import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { useNavigate, useLocation, Link } from 'react-router-dom';
// import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
// import api from '../../services/api';
import nivaasLogo from '../../assets/nivaas-logo.png';
import axios from 'axios';

const Login = () => {
  const { login, error, currentUser, organizationContext } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [formError, setFormError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  // const [orgName, setOrgName] = useState(localStorage.getItem('organization_name') || 'Select Homes');
  
  const { email, password } = formData;
  const [defaultsettings, setDefaultsettings] = useState([]);
  
  useEffect(() => {
    const fetchDefaultSettings = async () => {
      try {
        const settings_response = await axios.get('/api/saas/settings/default-settings');
        setDefaultsettings(settings_response.data);
      } catch (err) { 
        console.log('error');
      }
    };
    
    fetchDefaultSettings();
  }, []);
  
  // Helper function to get dashboard route based on role
  const getDashboardRoute = (role) => {
    switch (role) {
      case 'superadmin':
        return '/superadmin/dashboard';
      case 'admin':
        return '/admin/dashboard';
      case 'owner':
        return '/owner/dashboard';
      case 'guard':
        return '/guard/dashboard';
      case 'maintenance':
        return '/maintenance/dashboard';
      default:
        return '/login';
    }
  };
  
  // Redirect if already logged in, using client-side navigation
  useEffect(() => {
    console.log('Login component useEffect triggered - currentUser:', currentUser);
    if (currentUser && currentUser.role) {
      console.log('User already logged in, redirecting:', currentUser.role);
      const dashboardRoute = getDashboardRoute(currentUser.role);
      if (dashboardRoute !== '/login') {
        console.log('Navigating to:', dashboardRoute);
        navigate(dashboardRoute, { replace: true });
      }
    } else {
      console.log('No current user or no role, staying on login page');
    }
  }, [currentUser, navigate]);
  
  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  
  const onSubmit = async (e) => {
    e.preventDefault();
    const trimmedEmail = email.trim();
    const trimmedPassword = password.trim();
    
    if (!trimmedEmail || !trimmedPassword) {
      setFormError('Please provide both email/username and password');
      return;
    }

    // Add email format validation if input contains @ symbol
    if (trimmedEmail.includes('@') && !/\S+@\S+\.\S+/.test(trimmedEmail)) {
      setFormError('Please enter a valid email address');
      return;
    }
    
    try {
      setIsLoading(true);
      setFormError('');
      
      console.log('Login attempt:', { email: trimmedEmail, password: '********' });
      
      const orgDomain = location.state?.organizationDomain || organizationContext;
      console.log('Organization domain from location.state:', location.state?.organizationDomain);
      console.log('Organization domain from organizationContext:', organizationContext);
      console.log('Final organization domain being used:', orgDomain);
      
      // Clear any stored organization domain to prevent conflicts
      if (!orgDomain) {
        console.log('No organization domain provided, clearing any stored domain');
        localStorage.removeItem('organization_domain');
        sessionStorage.removeItem('organization_domain');
      }
      
      // Attempt login with trimmed values
      const user = await login(trimmedEmail, trimmedPassword, orgDomain);
      
      // If login successful, navigate based on user role
      if (user && user.role) {
        console.log('Login successful, navigating to dashboard for role:', user.role);
        const dashboardRoute = getDashboardRoute(user.role);
        if (dashboardRoute !== '/login') {
          navigate(dashboardRoute, { replace: true });
        }
      }
    } catch (error) {
      console.error('Login error:', error);
      setFormError(error.response?.data?.message || 'Failed to login. Please check your credentials.');
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div className="container">
      <div className="row justify-content-center mt-2">
        <div className="col-md-6">
          <div className="card shadow">
            <div className="card-body p-5">
              <div className="text-center mb-4">
                <img 
                src={defaultsettings.logo_url ? defaultsettings.logo_url : nivaasLogo}
                alt="Nivaas Logo" className="mb-3" style={{ maxWidth: '150px', height: 'auto' }} />
               
                <p className="text-muted">Sign in to your account</p>
              </div>
              
              {(formError || error) && (
                <div className="alert alert-danger" role="alert">
                  {formError || error}
                  {(formError || error)?.includes('organization') && (
                    <div className="mt-2">
                      <small className="text-muted">
                        If you&apos;re having trouble logging in, try clearing your browser data:
                      </small>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary ms-2"
                        onClick={() => {
                          localStorage.clear();
                          sessionStorage.clear();
                          window.location.reload();
                        }}
                      >
                        Clear Browser Data
                      </button>
                    </div>
                  )}
                </div>
              )}
              
              <form onSubmit={onSubmit}>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">Email or Username</label>
                  <input
                    type="text"
                    className="form-control"
                    id="email"
                    name="email"
                    value={email}
                    onChange={onChange}
                    placeholder="name@example.com or username"
                    
                  />
                </div>
                
                <div className="mb-4">
                  <label htmlFor="password" className="form-label">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    name="password"
                    value={password}
                    onChange={onChange}
                    placeholder="••••••••"
                    
                  />
                  <div className="text-end mt-2">
                    <Link 
                      to="/forgot-password" 
                      className="text-decoration-none small"
                      style={{ color: '#1F458E', fontSize: '13px' }}
                    >
                      <i className="fas fa-key me-1"></i>
                      Forgot Password?
                    </Link>
                  </div>
                </div>
                
                <button
                  type="submit"
                  className="btn w-100 py-2"
                  style={{ backgroundColor: '#1F458E', color: 'white' }}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Signing in...
                    </>
                  ) : (
                    'Sign In'
                  )}
                </button>

                <button
                  type="submit"
                  className="btn w-100 py-2 mt-2"
                  style={{ backgroundColor: '#1F458E', color: 'white' }}
                  onClick={() => navigate('/')}
                >Back to Home
                </button>
              </form>
            </div>
          </div>

          {/* Login Link Footer */}
          <div className="text-center mt-3">
            <small className="text-muted">
              Don&apos;t have an account?{' '}
              <Link 
                to="/register" 
                className="text-decoration-none" 
                style={{ color: '#1F458E', fontWeight: '500' }}
              >
                Register here
              </Link>
            </small>
          </div>
          
          {/* Privacy Policy Footer */}
          <div className="text-center mt-3">
            <small className="text-muted">
              By signing in, you agree to our{' '}
              <Link to="/privacy-policy" className="text-decoration-none" style={{ fontSize: '11px' }}>
                <i className="fas fa-shield-alt me-1"></i>
                Privacy Policy &amp; Terms
              </Link>
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login; 